<template>
    <div class="content ht-100v pd-0">
      <main-header txt="Зорчилт цагаар">
        <!-- <div></div>sdf -->
      </main-header>
      <div class="content-body pd-0-f" >
        <div class="container pd-0-f">
          <div class="card bd-0 bd-none" >
              <div class="card-body pd-0">
                <iframe src="http://zhut-dash-report.gosmart.mn/home/reports?r=b364d663-6652-4cad-a014-340d5c7ee467&u=%D0%A1.%D0%90%D0%B4%D0%BC%D0%B8%D0%BD&p=%D1%85%D1%8D%D1%80%D1%8D%D0%B3%D0%BB%D1%8D%D0%B3%D1%87" border="0" width="100%" style="border:none; height: calc(100vh - 60px);"></iframe>
              </div>
            </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import AsyncLoadError from "@/components/base/asyncLoadingError";
  import AsyncLoading from "@/components/base/asyncLoading";
  
  export default {
    components:{
      mainHeader: () => ({
        component: import("@/views/apps/penalty/components/header.vue"),
        loading: AsyncLoading,
        error: AsyncLoadError,
        delay: 100,
        timeout: 5000,
      }),
    },
  }
  </script>
  
  